// extracted by mini-css-extract-plugin
module.exports = {"root":"Homepage_root__thYjz","h1":"Homepage_h1__1juQa","h3":"Homepage_h3__1V7zk","video":"Homepage_video__2cNQy","content":"Homepage_content__qwI0M"};